import { render } from "./DeleteAccount.vue?vue&type=template&id=0c3db7be&scoped=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&lang=js"

import "./DeleteAccount.vue?vue&type=style&index=0&id=0c3db7be&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3db7be"]])

export default __exports__